import React from 'react';

interface TopProductItem {
  id: string;
  name: string;
  image?: string | null;
  sales: number;
  revenue: number;
  deleted?: boolean;
}

interface TopProductsProps {
  title: string;
  products: TopProductItem[];
  period: string;
}

const TopProducts: React.FC<TopProductsProps> = ({
  title,
  products,
  period,
}) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div className='bg-white rounded-lg shadow p-5'>
      <div className='flex items-center justify-between mb-4'>
        <h2 className='text-lg font-semibold'>{title}</h2>
        <span className='text-sm text-gray-500'>{period}</span>
      </div>

      <div className='space-y-4'>
        {products.map((product) => (
          <div key={product.id} className='flex items-center'>
            <div className='w-12 h-12 rounded-lg overflow-hidden flex-shrink-0'>
              {product.image ? (
                <img
                  src={product.image}
                  alt={product.name}
                  className='w-full h-full object-cover'
                />
              ) : (
                <div className='w-full h-full bg-gray-100 flex items-center justify-center text-xs text-gray-400'>
                  Không ảnh
                </div>
              )}
            </div>
            <div className='ml-4 flex-grow min-w-0'>
              <div className='flex justify-between gap-2 items-center'>
                <p className='font-medium text-gray-900 truncate' title={product.name || 'N/A'}>
                  {product.name || 'Sản phẩm đã ngưng bán'}
                </p>
                {product.deleted && (
                  <span className='shrink-0 px-2 py-0.5 text-xs font-medium rounded bg-red-100 text-red-700'>
                    Đã xóa
                  </span>
                )}
              </div>
              <div className='flex justify-between mt-1'>
                <p className='text-sm text-gray-500'>Đã bán: {product.sales}</p>
                <p className='text-sm font-medium text-gray-700 shrink-0 ml-2'>
                  {formatCurrency(product.revenue)}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {products.length === 0 && (
        <div className='text-center text-gray-500 py-6'>Không có dữ liệu</div>
      )}
    </div>
  );
};

export default TopProducts;
